import React, { Fragment, useState, useEffect } from 'react'
import { Card, CardBody, Col, Form, FormGroup, Label, Row } from 'reactstrap'
import { H3 } from '../../../../AbstractElements'
import { Categories, Collection, Color, Description, Fabric, ProductCategory, ProductDescription, ProductName, Selectdefault } from '../../../../Constant'
import API_BASE_URL from '../../../../Config/api'

const LeftformDesc = ({ handlesavechange, register, handleSubmit, errors }) => {
    const [categories, setCategories] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(true);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/categories`);
            if (!response.ok) {
                throw new Error('Failed to fetch categories');
            }
            const data = await response.json();
            setCategories(data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        } finally {
            setLoadingCategories(false);
        }
    };

    return (
        <Fragment>
            <Col lg='6'>
                <Card>
                    <CardBody>
                        <div className='product-info'>
                            <H3>{Description}</H3>
                            <Form onSubmit={handleSubmit(handlesavechange)} id="form1">
                                <div className='product-group'>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label>{ProductName}</Label>
                                                <input className={`form-control ${(errors.productname) && 'is-invalid'}`} type='text' placeholder='Enter Product Name' name='productname' {...register("productname", { required: true })} />
                                                <span className='text-danger'>{errors.productname && 'Product Name is required'}</span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label>{ProductDescription}</Label>
                                                <input className={`form-control ${(errors.description) && 'is-invalid'}`} type='textarea' placeholder='Enter Product description' name='description' {...register("description", { required: true })} />
                                                <span className='text-danger'>{errors.description && 'Add Some Description about this Product'}</span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                            <H3 attrH3={{ className: 'mt-4' }}>{Categories}</H3>
                            <Form onSubmit={handleSubmit(handlesavechange)} id="form1">
                                <div className="product-group">
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label htmlFor="exampleFormControlSelect3" className="form-label">{ProductCategory}</Label>
                                                <select id="exampleFormControlSelect3" className={`form-select ${(errors.category) && 'is-invalid'}`} {...register('category', { required: true })} disabled={loadingCategories}>
                                                    <option value={''}>{loadingCategories ? 'Loading...' : Selectdefault}</option>
                                                    {categories.map((category) => (
                                                        <option key={category.id} value={category.name}>
                                                            {category.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <span className='text-danger'>{errors.category && 'please Select Product type'}</span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label className="form-label">{Color}</Label>
                                                <input className={`form-control ${(errors.colour) && 'is-invalid'}`} type='text' placeholder='e.g. Cream, Gravel, Navy' name='colour' {...register('colour', { required: true })} />
                                                <span className='text-danger'>{errors.colour && 'Colour is required'}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label className="form-label">{Fabric}</Label>
                                                <input className={`form-control ${(errors.fabric) && 'is-invalid'}`} type='text' placeholder='e.g. Linen, Corduroy, Waffle' name='fabric' {...register('fabric', { required: true })} />
                                                <span className='text-danger'>{errors.fabric && 'Fabric is required'}</span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label className="form-label">{Collection}</Label>
                                                <input className={`form-control ${(errors.collection) && 'is-invalid'}`} type='text' placeholder="e.g. SS'27" name='collection' {...register('collection', { required: true })} />
                                                <span className='text-danger'>{errors.collection && 'Collection is required'}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup>
                                                <Label className="form-label">HSN Code</Label>
                                                <input className='form-control' type='text' placeholder='Enter HSN Code' name='hsn_code' {...register('hsn_code')} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}
export default LeftformDesc
